<template>
  <div class="container col-md-12">
    <h1>Other calculator</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>

    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <div>
        <md-content>
          <md-tabs md-dynamic-height md-border-bottom>
            <md-tab md-label="Entry Dates">
              <md-content class="md-padding">
                <table
                  style="text-align: center"
                  class="table table-striped table-bordered"
                >
                  <tr>
                    <td></td>
                    <td></td>
                    <td>Quarterly</td>
                    <td>Quarterly</td>
                    <td>Semi-Annual</td>
                    <td>Semi-Annual</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{
                        calcData.plan_basic_data.plan_end_date | date("M/DD")
                      }}</b>
                    </td>
                    <td><b>Month</b></td>
                    <td><b>1st</b></td>
                    <td><b> not 1st</b></td>
                    <td><b>1st</b></td>
                    <td><b> not 1st</b></td>
                  </tr>
                  <tr v-for="row in calcData.entry_dates">
                    <td>
                      <b>{{ row.date | date("M/DD") }}</b>
                    </td>
                    <td>{{ row.month }}</td>
                    <td>{{ row.quarterly_1st }}</td>
                    <td>{{ row.quarterly_not_1st }}</td>
                    <td>{{ row.semi_annual_1st }}</td>
                    <td>{{ row.semi_annual_not_1st }}</td>
                  </tr>
                </table>
              </md-content>
            </md-tab>
            <md-tab md-label="Eligibility Dates">
              <md-content class="md-padding">
                <table
                  style="text-align: center"
                  class="table table-striped table-bordered"
                >
                  <tr>
                    <th><b>Entry Date</b></th>
                    <td><b>EE</b></td>
                    <td><b>ER Match</b></td>
                    <td><b>ER Other</b></td>
                  </tr>

                  <tr>
                    <th><b>Immediate</b></th>
                    <td>{{ calcData.ee.immediate | date("MM/D/YYYY") }}</td>
                    <td>
                      {{ calcData.er_match.immediate | date("MM/D/YYYY") }}
                    </td>
                    <td>
                      {{ calcData.er_other.immediate | date("MM/D/YYYY") }}
                    </td>
                  </tr>

                  <tr>
                    <th><b>Monthly</b></th>
                    <td>{{ calcData.ee.monthly | date("MM/D/YYYY") }}</td>
                    <td>{{ calcData.er_match.monthly | date("MM/D/YYYY") }}</td>
                    <td>{{ calcData.er_other.monthly | date("MM/D/YYYY") }}</td>
                  </tr>

                  <tr>
                    <th><b>Quarterly</b></th>
                    <td>{{ calcData.ee.quarterly | date("MM/D/YYYY") }}</td>
                    <td>
                      {{ calcData.er_match.quarterly | date("MM/D/YYYY") }}
                    </td>
                    <td>
                      {{ calcData.er_other.quarterly | date("MM/D/YYYY") }}
                    </td>
                  </tr>

                  <tr>
                    <th><b>Semi-Annual</b></th>
                    <td>{{ calcData.ee.semi_annual | date("MM/D/YYYY") }}</td>
                    <td>
                      {{ calcData.er_match.semi_annual | date("MM/D/YYYY") }}
                    </td>
                    <td>
                      {{ calcData.er_other.semi_annual | date("MM/D/YYYY") }}
                    </td>
                  </tr>

                  <tr>
                    <th><b>Quarterly Month</b></th>
                    <td>{{ calcData.ee.quarterly_month }}</td>
                    <td>{{ calcData.er_match.quarterly_month }}</td>
                    <td>{{ calcData.er_other.quarterly_month }}</td>
                  </tr>

                  <tr>
                    <th><b>Semi-Annual Month</b></th>
                    <td>{{ calcData.ee.semi_annual_month }}</td>
                    <td>{{ calcData.er_match.semi_annual_month }}</td>
                    <td>{{ calcData.er_other.semi_annual_month }}</td>
                  </tr>
                </table>
              </md-content>
            </md-tab>
            <md-tab md-label="Escalation Dates">
              <md-content class="md-padding">
                <table class="table table-striped table-bordered text-center">
                  <tr>
                    <th>Pre-Tax</th>
                    <th>
                      {{
                        calcData.pre_tax_escalation_dates.entry_date
                          | date("MM/D/YYYY")
                      }}
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th colspan="3" scope="colgroup">Change Dates</th>
                  </tr>
                  <tr>
                    <th>Auto Esc</th>
                    <th>Temp Date</th>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Day</th>
                    <th>Date1</th>
                    <th>Date2</th>
                    <th>Date3</th>
                  </tr>
                  <tr v-for="row in calcData.pre_tax_escalation_dates.rows">
                    <td>
                      <b style="text-transform: capitalize;">{{
                        row.auto_esc
                      }}</b>
                    </td>
                    <td>{{ row.temp_date | date("MM/D/YYYY") }}</td>
                    <td>{{ row.year }}</td>
                    <td>{{ row.month }}</td>
                    <td>{{ row.day }}</td>
                    <td>{{ row.date1 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date2 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date3 | date("MM/D/YYYY") }}</td>
                  </tr>
                  <tr v-for="row in pre_tax_frequency_rows()">
                    <td>
                      <b style="text-transform: capitalize;">{{
                        row.auto_esc
                      }}</b>
                    </td>
                    <td>{{ row.temp_date | date("MM/D/YYYY") }}</td>
                    <td>{{ row.year }}</td>
                    <td>{{ row.month }}</td>
                    <td>{{ row.day }}</td>
                    <td>{{ row.date1 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date2 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date3 | date("MM/D/YYYY") }}</td>
                  </tr>
                </table>
              </md-content>

              <md-content class="md-padding">
                <table class="table table-striped table-bordered text-center">
                  <tr>
                    <th>Roth</th>
                    <th>
                      {{
                        calcData.roth_escalation_dates.entry_date
                          | date("MM/D/YYYY")
                      }}
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th colspan="3" scope="colgroup">Change Dates</th>
                  </tr>
                  <tr>
                    <th>Auto Esc</th>
                    <th>Temp Date</th>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Day</th>
                    <th>Date1</th>
                    <th>Date2</th>
                    <th>Date3</th>
                  </tr>
                  <tr v-for="row in calcData.roth_escalation_dates.rows">
                    <td>
                      <b style="text-transform: capitalize;">{{
                        row.auto_esc
                      }}</b>
                    </td>
                    <td>{{ row.temp_date | date("MM/D/YYYY") }}</td>
                    <td>{{ row.year }}</td>
                    <td>{{ row.month }}</td>
                    <td>{{ row.day }}</td>
                    <td>{{ row.date1 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date2 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date3 | date("MM/D/YYYY") }}</td>
                  </tr>
                  <tr v-for="row in roth_frequency_rows()">
                    <td>
                      <b style="text-transform: capitalize;">{{
                        row.auto_esc
                      }}</b>
                    </td>
                    <td>{{ row.temp_date | date("MM/D/YYYY") }}</td>
                    <td>{{ row.year }}</td>
                    <td>{{ row.month }}</td>
                    <td>{{ row.day }}</td>
                    <td>{{ row.date1 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date2 | date("MM/D/YYYY") }}</td>
                    <td>{{ row.date3 | date("MM/D/YYYY") }}</td>
                  </tr>
                </table>
              </md-content>
            </md-tab>
            <md-tab md-label="Employer Match">
              <md-content class="md-padding">
                <table
                  style="text-align: center"
                  v-if="calcData.deferral_employer_match"
                  class="table table-striped table-bordered"
                >
                  <tr>
                    <th>Deferral Rate</th>
                    <th>Cumulative</th>
                    <th>Match Rate</th>
                    <th>Excess Deferral</th>
                  </tr>
                  <tr v-for="row in calcData.deferral_employer_match.rows">
                    <td>{{ row.deferral_rate | numeral("0.2") }}%</td>
                    <td>{{ row.cumulative | numeral("0.2") }}%</td>
                    <td>{{ row.match_rate | numeral("0.2") }}%</td>
                    <td>{{ row.excess_deferral | numeral("0.2") }}%</td>
                  </tr>
                </table>
              </md-content>

              <md-content class="md-padding">
                <table
                  style="text-align: center"
                  v-if="calcData.yos_employer_match"
                  class="table table-striped table-bordered"
                >
                  <tr>
                    <th>Yos</th>
                    <th>Match Rate</th>
                    <th>Deferral</th>
                  </tr>
                  <tr v-for="row in calcData.yos_employer_match.rows">
                    <td>{{ row.yos }}</td>
                    <td>{{ row.match_rate | numeral("0.2") }}%</td>
                    <td>{{ row.deferral | numeral("0.2") }}%</td>
                  </tr>
                </table>
              </md-content>
            </md-tab>
            <md-tab md-label="Match By Year">
              <md-content class="md-padding">
                <table
                  style="text-align: center"
                  class="table table-striped table-bordered"
                >
                  <tr>
                    <th>Year</th>
                    <th>Eligible Comp</th>
                    <th>PT Annual</th>
                    <th>Roth Annual</th>
                    <th>PT Catchup</th>
                    <th>Roth Catchup</th>
                    <th>Eligible $</th>
                    <th>Eligible Rate</th>
                    <th>Cum Match</th>
                    <th>Match %</th>
                    <th>Deferral Rate</th>
                    <th>Match $</th>
                    <th>Max Match</th>
                    <th>Actual Match</th>
                    <th>Lost Match</th>
                    <th>FV LDi A</th>
                    <th>FV LDi B</th>
                    <th>FV LDi C</th>
                    <th>FV LDi D</th>
                    <th>FV LDi E</th>
                  </tr>
                  <tr v-for="row in calcData.match_by_year.rows">
                    <td>{{ row.year }}</td>
                    <td>
                      {{
                        row.eligible_compensation
                          | currency({ fractionCount: 0 })
                      }}
                    </td>
                    <td>
                      {{ row.pt_annual | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>
                      {{ row.roth_annual | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>
                      {{ row.pt_catchup | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>
                      {{ row.roth_catchup | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>{{ row.eligible | currency({ fractionCount: 0 }) }}</td>
                    <td>{{ row.eligible_rate | numeral("0.2") }}%</td>
                    <td>{{ row.cum_match | numeral("0.2") }}%</td>
                    <td>{{ row.match_percent | numeral("0.2") }}%</td>
                    <td>{{ row.deferral_rate | numeral("0.2") }}%</td>
                    <td>{{ row.match | currency({ fractionCount: 0 }) }}</td>
                    <td>
                      {{ row.max_match | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>
                      {{ row.actual_match | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>
                      {{ row.lost_match | currency({ fractionCount: 0 }) }}
                    </td>
                    <td>{{ row.fv_ldi_a | currency({ fractionCount: 0 }) }}</td>
                    <td>{{ row.fv_ldi_b | currency({ fractionCount: 0 }) }}</td>
                    <td>{{ row.fv_ldi_c | currency({ fractionCount: 0 }) }}</td>
                    <td>{{ row.fv_ldi_d | currency({ fractionCount: 0 }) }}</td>
                    <td>{{ row.fv_ldi_e | currency({ fractionCount: 0 }) }}</td>
                  </tr>
                </table>
              </md-content>
            </md-tab>
          </md-tabs>
        </md-content>
      </div>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_OTHER, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_OTHER,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  methods: {
    pre_tax_frequency_rows() {
      return this.filtered_frequency_rows(
        this.calcData.pre_tax_escalation_dates.frequency_rows
      );
    },
    roth_frequency_rows() {
      return this.filtered_frequency_rows(
        this.calcData.roth_escalation_dates.frequency_rows
      );
    },
    filtered_frequency_rows(rows) {
      return [rows[2], rows[0], rows[1]];
    }
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
